import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import LogoImage from "../../images/logo.jpg";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";

const Container = tw.div`relative bg-gray-200 -mx-8 -mb-8 px-8`;
const FiveColumns = tw.div`max-w-screen-xl mx-auto py-16 lg:py-20 flex flex-wrap justify-between`;

const Column = tw.div`md:w-1/5`;
const WideColumn = tw(
  Column
)`text-center md:text-left w-full md:w-2/5 mb-10 md:mb-0`;

const ColumnHeading = tw.h5`font-bold`;

const LinkList = tw.ul`mt-4 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:text-primary-500 hocus:border-primary-500 pb-1 transition duration-300`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl text-red-600 font-black`;

const CompanyDescription = tw.p`mt-4 max-w-xs font-medium text-sm mx-auto md:mx-0 md:mr-4 `;

const SocialLinksContainer = tw.div`mt-4 `;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900 transition duration-300 mr-4`}
  svg {
    ${tw`w-4 h-4`}
  }
`;
const CopyrightText = tw.p`text-center  font-medium tracking-wide text-base text-gray-600`;

const myNavFunc = () => {
  // If it's an iPhone..
  // if (
  //   navigator.platform.indexOf("iPhone") !== -1 ||
  //   navigator.platform.indexOf("iPod") !== -1 ||
  //   navigator.platform.indexOf("iPad") !== -1
  // ) {
  //   window.open(
  //     "maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=30.337844,59.955413"
  //   );
  // } else {
  window.open("https://maps.google.com/?q=Yorker Club");
  // }
};

export default () => {
  return (
    <Container>
      <FiveColumns>
        <WideColumn>
          <LogoContainer>
            <LogoImg src={LogoImage} />
            <LogoText>Yorker Club</LogoText>
          </LogoContainer>
          <CompanyDescription>
            Yorker Club is an Ultimate One stop Destination for Cricket 🏏 &
            Football ⚽️ Passionates .
          </CompanyDescription>
          <SocialLinksContainer>
            <SocialLink href="https://facebook.com">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://youtube.com">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
        </WideColumn>
        <Column>
          <ColumnHeading>Contact Now</ColumnHeading>
          <LinkList>
            <LinkListItem>
              <Link href="">Smit Patel 🏏⚽️</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="tel:+919537755454">+91 9537755454 ☎️</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="tel:+919537955454">+91 9537955454 ☎️</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="#"></Link>
            </LinkListItem>
          </LinkList>
        </Column>
        <Column>
          <ColumnHeading>Address 📍</ColumnHeading>
          <LinkList>
            <LinkListItem>
              <Link
                // href="#"
                onClick={() => {
                  myNavFunc();
                }}
              >
                Jaspur Canal Road 🗺️
              </Link>
            </LinkListItem>
            <LinkListItem>
              <Link
                href="#"
                onClick={() => {
                  myNavFunc();
                }}
              >
                Opp, Shivalay Petroleum (Indian Oil)
              </Link>
            </LinkListItem>
            <LinkListItem>
              <Link
                href="#"
                onClick={() => {
                  myNavFunc();
                }}
              >
                Nr.Jay Khodiyar Toughened Glass
              </Link>
            </LinkListItem>
            <LinkListItem>
              <Link
                href="#"
                onClick={() => {
                  myNavFunc();
                }}
              >
                Ahmedabad
              </Link>
            </LinkListItem>
          </LinkList>
        </Column>
      </FiveColumns>
      <CopyrightText style={{ marginBottom: 10 }}>
        <Link href="https://api.whatsapp.com/send?phone=+918200581702&text=Hello.">
          Website Conceptualised & Mainained by Kirtan Chauhan ❤️
        </Link>
      </CopyrightText>
    </Container>
  );
};
